export enum ExternalSsoProvidersEnum {
    Unknown = 'unknown',
    Internal = 'idp:internal',
    Google = 'idp:google',
    Office365 = 'idp:office365',
    SmartSchool = 'idp:smartschool',
    Lexipoort = 'idp:lexipoort',
    LeerIdAlinea = 'idp:leerid-alinea',
    LeerIdK3000 = 'idp:leerid-k3000',
}
